import { Model } from "@vuex-orm/core";

export default class Contact extends Model {
    static entity = "contact";
    static fields() {
        return {
            id: this.attr(null),
            form_of_address: this.attr(null).nullable(),
            company_city: this.attr(null).nullable(),
            company_country: this.attr(null).nullable(),
            company_email: this.attr(null).nullable(),
            company_name: this.attr(null).nullable(),
            company_post_code: this.attr(null).nullable(),
            company_street: this.attr(null).nullable(),
            company_website: this.attr(null).nullable(),
            email: this.attr(null).nullable(),
            first_name: this.attr(null).nullable(),
            last_name: this.attr(null).nullable(),
            mobile: this.attr(null).nullable(),
            phone: this.attr(null).nullable(),
            project_id: this.attr(null).nullable(),
            type: this.attr(1).nullable(),
            contact_types_id: this.attr(null).nullable(),
        };
    }
}
